import React, { useEffect } from 'react';
import './App.scss';
import Routes from './routes';
import { useTranslation } from 'react-i18next';
import ReactGA from 'react-ga';

function App() {
  const {i18n} = useTranslation()

  useEffect(() => {

    ReactGA.initialize('UA-183971727-1');
    ReactGA.pageview(window.location.pathname);

    const getLanguage = localStorage.getItem('language')

    if(getLanguage) {
      i18n.changeLanguage(getLanguage)
      localStorage.setItem('language', getLanguage);
    } else {
      localStorage.setItem('language', i18n.language);
    }
  }, [])

  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
